import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface ReservationModel extends BaseModel {
  variables?: { [key: string]: string } | ReservationVariables;
}

export interface ReservationVariables {
  Res1Image: string;
  Res2Image: string;
  Res1ImageHref: string;
  Res2ImageHref: string;
  Res1ImageAlt: string;
  Res2ImageAlt: string;
  ResPropertyName: string;
  ResAddress: string;
  ResTelephone: string;
  ResCheckIn: string;
  ResCheckOut: string;
  Res1ImageHrefSegmentRegex: string;
  Res2ImageHrefSegmentRegex: string;
}

export class ReservationInitVariables implements ReservationVariables {
  Res1Image = '';
  Res2Image = '';
  Res1ImageHref = '';
  Res2ImageHref = '';
  Res1ImageAlt = '';
  Res2ImageAlt = '';
  ResPropertyName = '';
  ResAddress = '';
  ResTelephone = '';
  ResCheckIn = '';
  ResCheckOut = '';
  Res1ImageHrefSegmentRegex = '';
  Res2ImageHrefSegmentRegex = '';
}

export class ReservationInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ReservationInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
